import React from 'react';
import { Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import styles from '../../styles/chatV2.module.css';

const UserMessage = ({ message, user }) => {
  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  };

  const getUserInitials = () => {
    if (user?.name) {
      return user.name
        .split(' ')
        .map((n) => n[0])
        .join('')
        .toUpperCase()
        .slice(0, 2);
    }
    return 'U';
  };

  return (
    <div className={`${styles.messageWrapper} ${styles.userMessageWrapper}`}>
      {/* Message Content (left side for user) */}
      <div className={`${styles.messageContent} ${styles.userMessageContent}`}>
        <div className={`${styles.messageBubble} ${styles.userBubble}`}>
          <p className={styles.userText}>{message.content}</p>
        </div>

        {/* Timestamp */}
        <div className={`${styles.messageFooter} ${styles.userMessageFooter}`}>
          <span className={styles.timestamp}>
            {formatTimestamp(message.timestamp)}
          </span>
        </div>
      </div>

      {/* User Avatar (right side) */}
      <div className={styles.avatarContainer}>
        <Avatar
          size={36}
          className={styles.userAvatar}
          style={{
            backgroundColor: '#1677ff',
            color: '#ffffff',
          }}
        >
          {getUserInitials()}
        </Avatar>
      </div>
    </div>
  );
};

export default UserMessage;
